import React, { useEffect, useState } from "react";
import queryString from 'query-string'
import { useLocation } from 'react-router-dom';
import { getBannerSettings } from '../Services/authService';

const ClientError = () => {
  const { search } = useLocation();
  let [parms, setParms] = useState();
  let [isRunning, setIsRunning] = useState(false);
  let [bannerResult, setbannerResult] = useState('');

  useEffect(() => {
    const requestParms = queryString.parse(search);
    setParms(requestParms);
    setIsRunning(true);
        getBannerSettings().then(result => {
            bannerResult = result.data; setbannerResult(result.data);

        }).catch(err=>{
            //handleError(null,err);
            console.error("BannerSettings error", err);
            setbannerResult({"BannerMessageKey": "", "AllowLogin": true});
        }).finally(()=>{
            setIsRunning(false);
        });    
  }, []);

  return (
    <div style={{textAlign:"center", padding:"32px"}}>
      
      <h1>Sorry, we seem to have encountered a problem</h1>
      <div>
        <p>It seems that something has gone wrong. Please try again later or contact us if the problem persists.</p>
      </div>
      
      <h3 style={{marginTop: "8rem"}}>Additional Information</h3>
      <div style={{display: "block", width: "50%", margin:"16px auto", textAlign: "left"}}>
        {parms ? 
          <div>
            <p>Request Paramters:</p>
            <pre>{JSON.stringify(parms, null, 2)}</pre>
          </div> : 
          <div>Unfortunately, we don't have any additional information about this event.</div>
        }  
      </div>
    </div>
  );
};
  
export default ClientError;